import React from 'react';
import cn from 'classnames';

import { CollectionAsset } from '@kaltura-ott/tvpil-shared';

import CollectionCardContainer from 'components/widgets/CardView/Collection/CollectionCardContainer/CollectionCardContainer';
import DynamicRailViewer from 'components/widgets/Rail/components/DynamicRailViewer/DynamicRailViewer';
import { useRailContext } from 'components/widgets/Rail/components/RailProvider/RailProvider';
import Title from 'components/widgets/Rail/components/Title/Title';
import { useApplyStyles } from 'components/widgets/Rail/hooks/useApplyStyles/useApplyStyles';
import { useWidgetContext } from 'context/widgetProvider/widgetProvider';

import styles from './CollectionRailContainer.module.scss';

function CollectionRailContainer() {
  // using version v2 of the rail provider
  const { wrapperRef, refElementInner, componentHeight } = useRailContext();
  const { settings, data } = useWidgetContext<CollectionAsset>();
  const handleRef = useApplyStyles(settings);
  const { hasNextPage, totalCount, items } = data;

  return (
    <div ref={handleRef} className={cn(styles.container)}>
      <div ref={refElementInner}>
        <Title
          hasNextPage={!!hasNextPage}
          totalCount={totalCount}
          itemsLength={items.length}
          forwardHeaderRef={handleRef}
          railSettings={settings}
        />
        <div
          ref={wrapperRef}
          style={{
            height: componentHeight,
          }}
        >
          <DynamicRailViewer<CollectionAsset> railData={data}>
            {({ imageHeight, itemWidth, item }) => (
              <CollectionCardContainer imageHeight={imageHeight} itemWidth={itemWidth} data={item} />
            )}
          </DynamicRailViewer>
        </div>
      </div>
    </div>
  );
}

export default CollectionRailContainer;
